module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.50145685.ttf";